import get from 'lodash/get';
import {
  PCP_PROVIDER_ANSWER,
  PCP_NOT_LISTED_VALUE,
} from '../constants/pcpAnswer';
import { DEFAULT_EMPTY_VALUE } from '../constants/strings';

export const getPCPDictionaries = ({ formatMessage }) => {
  const pcpAnswers = {
    Y: formatMessage({ id: 'common.yes' }),
    N: formatMessage({ id: 'common.no' }),
    U: formatMessage({ id: 'common.preferNotToSay' }),
  };

  const considerUsAsYourPCPAnswers = {
    Y: formatMessage({ id: 'common.yes' }),
    N: formatMessage({ id: 'common.no' }),
  };

  return {
    considerUsAsYourPCPAnswers,
    pcpAnswers,
  };
};

export const getConsiderUsPcpUiAnswer = ({
  considerUsAsYourPcp,
  formatMessage,
}) => {
  switch (considerUsAsYourPcp) {
    case PCP_PROVIDER_ANSWER.Y:
    case true:
      return formatMessage({ id: 'common.yes' });
    case false:
    case PCP_PROVIDER_ANSWER.N:
      return formatMessage({ id: 'common.no' });
    default:
      return DEFAULT_EMPTY_VALUE;
  }
};

export const getConsiderUsAsYourPCPPayload = formData => {
  const considerUsPcp = get(formData, 'considerUsPcp', null);

  if (!considerUsPcp) {
    return null;
  }

  return considerUsPcp === PCP_PROVIDER_ANSWER.Y;
};

export const getInitialPcpFormConsiderUsPcpValue = considerUsPcp => {
  let considerUsPcpValue = null;

  if (considerUsPcp === true) {
    considerUsPcpValue = PCP_PROVIDER_ANSWER.Y;
  }

  if (considerUsPcp === false) {
    considerUsPcpValue = PCP_PROVIDER_ANSWER.N;
  }

  return considerUsPcpValue;
};

export const getPcpNotListedOption = formatMessage => ({
  label: formatMessage({ id: 'common.myPcpNotListed' }),
  value: PCP_NOT_LISTED_VALUE,
});

export const convertPrimaryCareProviderDataToFormOption = (
  provider,
  pcpName,
  formatMessage,
) => {
  if (pcpName) {
    return getPcpNotListedOption(formatMessage);
  }

  if (!provider) return null;

  const option = get(provider, 'label', '');

  if (option) {
    return provider;
  }

  const firstName = get(provider, 'firstName', '');
  const lastName = get(provider, 'lastName', '');
  const id = get(provider, 'id', '');

  return {
    label: `${firstName} ${lastName}`,
    value: id,
  };
};



// WEBPACK FOOTER //
// ./src/utils/getPCPDictionaries.js